import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

import useAppSelector from 'hooks/useAppSelector';
import { initializeGa4 } from 'features/commonSlice';
import { sendPageviewToGa4 } from 'utils/googleAnalytics4';

const RouteChangeTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { ga4Initialized } = useAppSelector((state) => state.common);

  useEffect(() => {
    if (!window.location.href.includes('://local')) {
      // do not send to localhost
      // e.g., http://localhost:3000 , https://local.shortbread.io
      ReactGA.initialize(process.env.REACT_APP_GA4_TRACKING_ID ?? '');
    }
    dispatch(initializeGa4());
  }, [dispatch]);

  useEffect(() => {
    if (ga4Initialized) {
      const pathname = location.pathname;

      if ((pathname.startsWith('/auctions') && pathname !== '/auctions/new') || pathname === '/bids') {
        // this path is auction list page, or auction detail page, or bids list page
        // this page information will be send in each component
        // due to send proper document title
      } else {
        sendPageviewToGa4(document.title);
      }
    }
  }, [ga4Initialized, location.pathname]);
};

export default RouteChangeTracker;
